<template>
  <div class="card">
    <div class="top">
      <div class="t_left">
        <span @click="$emit('changeShowCard', 0)" v-if="showCard!=-1">{{ lang.overviewOfProgress }}</span>
        <span @click="$emit('changeShowCard', 1)" class="active">{{lang.difficultProblems}}</span>
        <span @click="$emit('changeShowCard', 2)" v-if="showCard!=-1">{{ lang.abilityStratification }}</span>
        <span @click="$emit('changeShowCard', 3)" v-if="showCard!=-1">{{lang.teachingSuggestions}}</span>
      </div>
      <div class="t_right" v-if="false">
        <img src="../../../../assets/img/teachingMode/changeUp.png" :style="{cursor:showCard>0?'pointer':'not-allowed'}" @click="$emit('changeShowCard',0)">
        <img src="../../../../assets/img/teachingMode/changeDown.png" :style="{cursor:showCard<3?'pointer':'not-allowed'}" @click="$emit('changeShowCard',1)">
      </div>
    </div>
    <div class="main">
      <div class="m_item" v-for="(item, index) in cardData" :key="index">
        <div
          class="m_item_top"
          :style="{ background: item.bgColor, color: item.tColor }"
        >
          <div>
            {{ item.title }}<span>（{{ item.percentage }}）</span>
          </div>
          <span>{{ item.type }}</span>
        </div>
        <div class="m_item_content">
          <div
            class="m_item_content_item"
            v-for="(item2, index2) in item.content"
            :key="index2"
          >
          <span>{{ item2.txt }}</span>
          <div>
            <span>{{ item2.num }}{{ lang.times }}</span>
            <div @click="lookDetail(item2.user)">{{lang.viewDetails}}</div>
          </div>
        </div>
        </div>
      </div>
    </div>
    <difficultProblemsDialog ref="difficultProblemsDialogRef" :tid="tid"/>
  </div>
</template>

<script>
import { myMixin } from "@/common/mixin";
import difficultProblemsDialog from './dialog/difficultProblemsDialog.vue'
export default {
  mixins: [myMixin],
  components:{
    difficultProblemsDialog
  },
  props:{
    analysisData:{
      type:Array,
      default:()=>{
        return []
      }
    },
    showCard:{
      type:Number,
      default:0
    },
    tid:{
      type:String,
      default:''
    },
    exportBoolean:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      // cardData: [],
      statusList: [
				this.lang.unfinished,
				this.lang.completed,
				this.lang.pause,
				this.lang.stop,
			],
    };
  },
  computed: {
    cardData() {
      let _result = [];

      if (this.analysisData && this.analysisData.length > 0) {
        _result = JSON.parse(JSON.stringify(this.analysisData));
      }

      return _result;
    },
  },
  methods:{
    generated(list,num=0){
      return new Promise((resolve)=>{
      let _msg = ``
      list.forEach((s) => {
				_msg += `学生：${s.name}\n总结：${s.summary}\n总节点数量：${
					s.stage
				}\n任务状态：${this.statusList[s.status]}\nID：${s.id}\n`;
				s.nodeData.forEach((n, nIndex) => {
					_msg += `【节点${(nIndex + 1).toString().padStart(2, "0")} ${
						n.messageList[0] ? n.messageList[0].aiName : "-"
					}】表情：${
						n.status == "0" ? "微笑" : n.status == "1" ? "不高兴" : "无表情"
					}\n`;
					n.messageList.forEach((m) => {
						_msg += `${m.userName}(${m.chatTime})：\n${m.userContent}\n${m.aiName}：\n${m.aiContent}\n`;
					});
				});
				_msg += "\n";
			});

      let _msg2 = `NOTICE
Role: 你是一个专业的教育数据分析师，需要基于学生在AI学习助手中的对话记录，识别和归类学生在学习过程中遇到的疑难问题，为教师提供学生学习困难的全面画像。
Language: Please use the same language as the user requirement, if the user speaks Chinese, the specific text of your answer should also be in Chinese.
ATTENTION: Use '##' to SPLIT SECTIONS, not '#'. Output format carefully referenced "Format example".
Instruction: Based on the context, follow "Format example", write content

#Context
## 任务
你需要完成：
1. 从学生对话中提取具体的学习困难和问题
2. 将相似或相关的问题归类到同一问题类型下
3. 统计每个具体问题的出现频次（至少2人次才纳入统计）
4. 按照问题的普遍性和重要程度进行排序
5. 严格按照输出格式输出内容

# 输入信息

## 学生学习对话数据
${_msg}

## 数据分析范围
- 所有学生的完整学习对话记录
- 学生的困惑表达、错误回答、求助行为
- AI系统的问题反馈和指导记录
- 学习过程中的卡点和重复出现的问题

# 问题识别与分类框架

## 1. 概念理解困难
学生对核心概念、定义、原理的理解出现偏差或困惑
**识别标志**：
- "不理解"、"不明白"、"什么意思"
- 概念解释错误、混淆相似概念
- 反复询问基础定义、原理说明
- 对抽象概念难以理解和应用

## 2. 逻辑推理困难  
学生在思维逻辑、因果关系、推理过程中遇到障碍
**识别标志**：
- 逻辑链条断裂、推理步骤混乱
- 因果关系颠倒、条件判断错误  
- "为什么"、"怎么推出的"类疑问
- 无法建立知识点之间的联系

## 3. 操作技能困难
学生在具体操作、步骤执行、方法应用中遇到困难
**识别标志**：
- "怎么做"、"不会操作"、"步骤错乱"
- 方法选择错误、工具使用不当
- 操作顺序混乱、关键步骤遗漏
- 技能应用不熟练、错误率高

## 4. 应用迁移困难
学生难以将所学知识迁移到新情境或实际问题中
**识别标志**：
- 理论学会但实际应用困难
- 不同题型或情境下无法举一反三
- "这个怎么用"、"在哪里用"类困惑
- 知识孤立化，缺乏灵活运用

## 5. 学习策略困难
学生在学习方法、策略选择、自我调节方面存在问题
**识别标志**：
- "不知道怎么学"、"学不会"
- 学习方法单一、效率低下
- 无法进行自我监控和调节
- 重复性错误、缺乏反思

## 6. 情绪动机问题
学生的学习情绪、动机、态度影响学习效果
**识别标志**：
- "不想学"、"太难了"、"很烦"
- 畏难情绪、挫败感、焦虑表现
- 学习兴趣下降、参与度降低
- 消极态度、逃避行为

## 7. 交互沟通问题
学生与AI系统或学习内容的交互出现障碍
**识别标志**：
- 表达不清、理解偏差
- 无法准确描述问题或困惑
- 对AI反馈理解错误
- 交互方式不当、沟通效果差

# 问题提取策略

## 关键词识别法
**直接困惑表达**：
- 疑问词：什么、怎么、为什么、如何、哪里
- 否定表达：不会、不懂、不理解、不知道
- 求助信号：帮助、教教我、不明白、困惑

**间接问题信号**：
- 重复提问相同或相似问题
- 回答错误后的修正和再次错误
- 长时间停滞或无响应
- 回答过于简短或偏离主题

## 模式识别法
**高频错误模式**：
- 同一类型错误反复出现
- 相同问题被多名学生提及
- 特定学习节点的集中困难

**困难聚集分析**：
- 某个知识点的普遍困难
- 特定学习阶段的共同问题
- 关键转换节点的理解障碍

# 统计与排序规则

## 频次统计标准
- **单人重复**：同一学生多次遇到相同问题，计为该问题的多个频次
- **多人共同**：不同学生遇到相同问题，分别计入频次
- **最低阈值**：仅统计出现2人次及以上的问题
- **相似归并**：表述不同但本质相同的问题归并统计

## 重要性排序依据
1. **频次高低**：出现次数多的问题优先级更高
2. **影响程度**：对学习进度影响大的问题排序靠前
3. **普遍性**：影响学生面广的问题重点关注
4. **关键性**：核心知识点相关问题重要性更高

# 其他提示

1. **基于事实分析，保持客观中性**：所有分析结论必须基于实际的对话数据，避免主观推测；使用专业术语，避免对学生进行负面标签化或价值判断；不仅识别问题，也要发现学生的优势和成功模式
2. **注重可操作性**：提供的洞察和建议应该具体可行，能指导教师采取实际行动；优先分析最新的学习状态和最近的变化趋势
3. **考虑个体差异**：认识到不同学生的学习方式、节奏和需求存在差异
4. **数据隐私保护**：在分析过程中保护学生隐私，使用适当的概括性描述
5. **完整性检查**：确保所有学生的学习状态都被纳入分析范围，无遗漏

基于提供的学生学习对话数据，运用上述分析框架识别和归类疑难问题。

# Format example
[{"title":"{问题类型}","type":"高频","percentage":"{百分比}","bgColor":"#BCE685","tColor":"#000","content":[{"txt":"{具体问题描述}","num":"{次数}","user":[{"id":"数据id","performance":"{学生典型表现}","suggestion":"{针对性建议}"},{"id":"数据id","performance":"{学生典型表现}","suggestion":"{针对性建议}"}]},{"txt":"{具体问题描述}","num":"{次数}","user":[{"id":"数据id","performance":"{学生典型表现}","suggestion":"{针对性建议}"},{"id":"数据id","performance":"{学生典型表现}","suggestion":"{针对性建议}"}]}]},{"title":"{问题类型}","type":"中频","percentage":"{百分比}","bgColor":"#3681FC","tColor":"#fff","content":[{"txt":"{具体问题描述}","num":"{次数}","user":[{"id":"数据id","performance":"{学生典型表现}","suggestion":"{针对性建议}"},{"id":"数据id","performance":"{学生典型表现}","suggestion":"{针对性建议}"}]},{"txt":"{具体问题描述}","num":"{次数}","user":[{"id":"数据id","performance":"{学生典型表现}","suggestion":"{针对性建议}"},{"id":"数据id","performance":"{学生典型表现}","suggestion":"{针对性建议}"}]}]},{"title":"{问题类型}","type":"低频","percentage":"{百分比}","bgColor":"#D9D9D9","tColor":"#000","content":[{"txt":"{具体问题描述}","num":"{次数}","user":[{"id":"数据id","performance":"{学生典型表现}","suggestion":"{针对性建议}"},{"id":"数据id","performance":"{学生典型表现}","suggestion":"{针对性建议}"}]},{"txt":"{具体问题描述}","num":"{次数}","user":[{"id":"数据id","performance":"{学生典型表现}","suggestion":"{针对性建议}"},{"id":"数据id","performance":"{学生典型表现}","suggestion":"{针对性建议}"}]}]}]
`

      let message = [{ role: "user", content: _msg2 }];
      this.chat_no_stream(message)
          .then((res) => {
            try {
              if (res) {
                let _group = JSON.parse(res);
                resolve(_group);
              } else {
                // 若response为空视为catch流程
                if (num < 4) {
                  this.generated(list, num + 1).then(resolve);
                } else {
                  resolve([]);
                }
              }
            } catch (error) {
              // 若解析失败则重试，最多5次（num从0 ~ 4）
              if (num < 4) {
                this.generated(list, num + 1).then(resolve);
              } else {
                resolve([]);
              }
            }
          })
          .catch(() => {
            // catch异常也重试，最多5次
            if (num < 4) {
              this.generated(list, num + 1).then(resolve);
            } else {
              resolve([]);
            }
          });
      });
    },
    // 查看详细按钮
    lookDetail(data){
      console.log(data)
      this.$refs.difficultProblemsDialogRef.open(data)
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  width: 100%;
  height: auto;
  border: 1px solid rgba(245, 248, 255, 0.25);
  box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.08);
  box-shadow: 0px 16px 24px 2px rgba(0, 0, 0, 0.04);
  box-shadow: 0px 6px 30px 5px rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(16.700000762939453px);
  border-radius: 12px;
  box-sizing: border-box;
  gap: 20px;
  .top {
    width: 100%;
    height: 50px;
    background: #fff;
    border-radius: 12px 12px 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 20px;
    .t_left {
      white-space: nowrap;
      display: flex;
      gap: 20px;
      & > span {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: #797979;
        cursor: pointer;
      }
      &>.active{
        font-size: 18px;
        color: #000;
      }
    }
    .t_right{
      display: flex;
      gap: 20px;
      &>img{
        width: 25px;
        height: 25px;
        cursor: pointer;
      }
    }
  }
  .main {
    width: 100%;
    height: auto;
    background: #fafafa;
    box-sizing: border-box;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    .m_item {
      width: 100%;
      height: auto;
      background: rgba(255, 255, 255, 0.9);
      box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.08);

      box-shadow: 0px 16px 24px 2px rgba(0, 0, 0, 0.04);

      box-shadow: 0px 6px 30px 5px rgba(0, 0, 0, 0.05);
      border: 1px solid rgba(245, 248, 255, 0.25);
      backdrop-filter: blur(16.700000762939453px);
      box-sizing: border-box;
      border-radius: 12px;
      .m_item_top{
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0 20px;
        border-radius: 12px 12px 0 0;
        & > div {
          font-weight: 500;
          font-size: 16px;
          line-height: 24px;
        }
        & > span {
          font-weight: 400;
          font-size: 14px;
          line-height: 24px;
        }
      }
      .m_item_content{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 10px 20px;
        display: flex;
        flex-direction: column;
        background: #fff;
        border-radius: 0 0 12px 12px;
        .m_item_content_item{
          width: 100%;
          height: 50px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          box-sizing: border-box;
          border-bottom: 1px solid #e7e7e7;
          &:last-child {
            border: none !important;
          }
          &>span{
            display: block;
            max-width: calc(100% - 150px);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-weight: 400;
            font-size: 14px;
            line-height: 24px;
            color: rgba(0, 0, 0, 1);
          }
          &>div{
            width: 150px;
            height: 100%;
            display: flex;
            gap: 20px;
            align-items: center;
            justify-content: flex-end;
            &>span{
              font-weight: 400;
              font-size: 14px;
              color: rgba(0, 0, 0, 1);
            }
            &>div{
              font-weight: 400;
              font-size: 14px;
              color: rgba(5, 96, 253, 1);
              cursor: pointer;
              &:hover{
                color: rgba(5, 96, 253, 0.8);
              }
            }
          }
        }
      }
    }
  }
}
</style>
